import { InputField } from '@design-system';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

interface AddCustomsCodeProps {
  className: string;
  countryCode: string;
  defaultValue?: string;
  error: boolean;
  onChange: (value: string) => void;
}

export const AddCustomsCode: FC<AddCustomsCodeProps> = ({
  className,
  countryCode,
  defaultValue,
  error,
  onChange,
}) => {
  const { t } = useTranslation('product');

  return (
    <div className={className}>
      <InputField
        defaultValue={defaultValue}
        error={error ? t('drawers.review.draw.customs.error') : ''}
        hideErrorMessage
        id="customsCode"
        label={t(`drawers.review.draw.customs.labels.${countryCode}`)}
        name="customsCode"
        onChange={(ev) => {
          onChange(ev.currentTarget.value);
        }}
        required
      />
      <p className="mt-2 text-xs text-neutral-4">
        {t('drawers.review.draw.customs.text', {
          country: `${t(`countries:${countryCode}`)}`,
          label: t(`drawers.review.draw.customs.labels.${countryCode}`),
        })}
      </p>
    </div>
  );
};
